import { c as _c } from "react/compiler-runtime";
import type { PublicWorkflowKind } from '@onefootprint/request-types/dashboard';
import { useTranslation } from 'react-i18next';
const useOnboardingKindText = () => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "onboardings.kind"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    t
  } = useTranslation("entity-details", t0);
  let t1;
  if ($[1] !== t) {
    t1 = kind => {
      switch (kind) {
        case "kyc":
        case "alpaca_kyc":
          {
            return t(_temp);
          }
        case "kyb":
          {
            return t(_temp2);
          }
        case "document":
          {
            return t(_temp3);
          }
        case "adhoc_vendor_call":
          {
            return t(_temp4);
          }
        case "continuous_monitoring_watchlist_check":
          {
            return t(_temp5);
          }
        case "agent":
          {
            return t(_temp6);
          }
        case "other_ad_hoc":
          {
            return t(_temp7);
          }
      }
    };
    $[1] = t;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default useOnboardingKindText;
function _temp($_5) {
  return $_5.kyc;
}
function _temp2($_4) {
  return $_4.kyb;
}
function _temp3($_3) {
  return $_3.document;
}
function _temp4($_2) {
  return $_2.adhocVendorCall;
}
function _temp5($_1) {
  return $_1.continuousMonitoring;
}
function _temp6($_0) {
  return $_0.agent;
}
function _temp7($) {
  return $.otherAdHoc;
}